import { render } from "./WhatsAppIcon.vue?vue&type=template&id=22cdbf7e&scoped=true"
const script = {}

import "./WhatsAppIcon.vue?vue&type=style&index=0&id=22cdbf7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cdbf7e"]])

export default __exports__